import { render } from "./blocksGallery.vue?vue&type=template&id=009ee20e&scoped=true"
import script from "./blocksGallery.vue?vue&type=script&lang=js"
export * from "./blocksGallery.vue?vue&type=script&lang=js"

import "./blocksGallery.vue?vue&type=style&index=0&id=009ee20e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009ee20e"]])

export default __exports__